<template>
  <div class="row mb-3">
    <div v-for="field in fields" :key="field.key" :class="colClass">
      <label class="d-block">
        {{ field.label }}
      </label>
      <template v-if="field.type === 'checkbox'">
        <input
          type="checkbox"
          v-model="internalRecord[field.key]"
          class="custom-checkbox"
          @change="emitCheckboxChange(field.key)"
        />
      </template>
      <template v-else-if="field.type === 'date'">
        <input
          type="date"
          v-model="internalRecord[field.key]"
          class="form-control date-input"
          :placeholder="field.label"
          @change="field.onChange && field.onChange(internalRecord[field.key])"
        />
      </template>
      <template v-else-if="field.type === 'datetime'">
        <input
          type="datetime-local"
          :value="getNestedValue(internalRecord, field.key)"
          @input="
            setNestedValue(internalRecord, field.key, $event.target.value)
          "
          class="form-control date-input"
          :placeholder="field.label"
        />
      </template>
      <template v-else-if="field.type === 'textarea'">
        <el-input
          type="textarea"
          v-model="internalRecord[field.key]"
          :placeholder="field.label"
          class="w-100"
          :rows="field.rows || 3"
        />
      </template>
      <template v-else-if="field.type === 'select'">
        <AIVSelect
          v-model="internalRecord[field.key]"
          :options="field.options"
          :placeholder="field.label"
          @input="(val) => field.onChange && field.onChange(val)"
        />
      </template>
      <template v-else-if="field.type === 'time'">
        <el-input type="time" v-model="internalRecord[field.key]" />
      </template>
      <template v-else-if="field.type === 'ssn'">
        <div class="position-relative">
          <input
            id="ssn"
            :type="ssnInputType"
            :value="formattedSSN"
            @input="formatSSN"
            maxlength="11"
            placeholder="9 Digit SSN..."
            class="form-control ssn-input"
          />
          <i
            :class="ssnVisible ? 'fa-solid fa-eye-slash' : 'fa-solid fa-eye'"
            @click="toggleSSNVisibility"
            class="position-absolute"
            style="
              top: 50%;
              right: 12px;
              transform: translateY(-50%);
              cursor: pointer;
              color: #ccc;
            "
            aria-hidden="true"
          ></i>
        </div>
      </template>
      <template v-else>
        <el-input
          v-model="internalRecord[field.key]"
          :placeholder="field.label"
          class="w-100"
        />
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: "ModalRow",
  props: {
    record: {
      type: Object,
      required: true,
    },
    fields: {
      type: Array,
      required: true,
      validator(arr) {
        return (
          arr.length >= 1 &&
          arr.length <= 3 &&
          arr.every((f) => f.label && f.key)
        );
      },
    },
  },
  data() {
    return {
      internalRecord: { ...this.record },
      ssnVisible: false,
      ssnInputType: "password",
      ssn: "",
    };
  },
  computed: {
    colClass() {
      return `col-md-${12 / this.fields.length}`;
    },
    formattedSSN() {
      const ssn = this.internalRecord?.ssn || "";
      const numbers = ssn.replace(/\D/g, "").slice(0, 9);
      const parts = [];
      if (numbers.length > 0) parts.push(numbers.slice(0, 3));
      if (numbers.length > 3) parts.push(numbers.slice(3, 5));
      if (numbers.length > 5) parts.push(numbers.slice(5, 9));
      return parts.join("-");
    },
  },
  watch: {
    record: {
      handler(newVal) {
        if (JSON.stringify(newVal) !== JSON.stringify(this.internalRecord)) {
          this.internalRecord = { ...newVal };
        }
      },
      deep: true,
    },
    internalRecord: {
      handler(newVal) {
        if (JSON.stringify(newVal) !== JSON.stringify(this.record)) {
          this.$emit("update:record", { ...newVal });
        }
      },
      deep: true,
    },
  },
  methods: {
    toggleSSNVisibility() {
      switch (this.ssnInputType) {
        case "password":
          this.ssnInputType = "text";
          break;
        case "text":
          this.ssnInputType = "password";
          break;
      }
    },
    formatSSN(event) {
      const raw = event.target.value.replace(/\D/g, "").slice(0, 9);
      this.$set(this.internalRecord, "ssn", raw);
    },
    getNestedValue(obj, path) {
      return path.split(".").reduce((o, k) => (o || {})[k], obj);
    },
    setNestedValue(obj, path, value) {
      const keys = path.split(".");
      const lastKey = keys.pop();
      const target = keys.reduce((o, k) => {
        if (!o[k]) o[k] = {};
        return o[k];
      }, obj);
      this.$set(target, lastKey, value);
    },
    emitCheckboxChange(key) {
      this.$emit('update-record', {
        key,
        value: this.internalRecord[key],
        id: this.record.id,
      });
    },
  },
};
</script>
<style scoped>
label.d-block {
  margin-bottom: 2px !important;
}
.custom-checkbox {
  margin: 5px 0 0;
  -webkit-appearance: none;
  appearance: none;
  width: 26px;
  height: 26px;
  border: 1px solid #bdbdbd;
  border-radius: 0.25em;
  position: relative;
  cursor: pointer;
}
.custom-checkbox:checked {
  background-color: #656565;
}
.custom-checkbox:checked::after {
  content: "";
  position: absolute;
  left: 0.55em;
  top: 0.3em;
  width: 0.5em;
  height: 0.9em;
  border: solid white;
  border-width: 0 0.25em 0.25em 0;
  transform: rotate(45deg);
}
</style>
